<script setup lang="ts">
import { computed } from 'vue';
import { DentalAndVisionApplicant } from '@/application/shared/domain/DentalAndVisionApplicant';
import { RenderName, RenderEmail, RenderAddress, RenderPhone, RenderYesNoAnswer, RenderSsn } from '@hfc/ui-core';

const props = withDefaults(defineProps<{
  guardian: DentalAndVisionApplicant,
  primaryApplicant: DentalAndVisionApplicant,
  iconsColor?: string,
  titleClass?: string,
}>(), {
  iconsColor: 'text-blue-500',
  titleClass: 'text-sm font-medium'
});

const address = computed(() => {
  if (props.guardian.is_address_same_as_main) {
    return props.primaryApplicant.main_address;
  }

  return props.guardian.main_address;
});

</script>
<template>
  <div class="flex flex-1 flex-col">
    <div class="flex flex-1 flex-col sm:flex-row pt-4 space-y-3 sm:space-y-0">
      <div class="flex-1 space-y-3">
        <div class="flex-1 font-bold ">
          <RenderName :first-name="guardian.first_name" :middle-name="guardian.middle_name" :last-name="guardian.last_name" :suffix="guardian.suffix" :icon-color="iconsColor" />
        </div>
        <div>
          <RenderSsn v-if="guardian.ssn" :ssn="guardian.ssn.toString()" icon-class="mr-2 text-gray-400" show-obfuscation-toggle obfuscation-toggle-class="text-sm text-blue-500" obfuscate />
        </div>
        <div v-if="!guardian.is_address_same_as_main">
          <RenderAddress
            :line-one="address?.line_one"
            :line-two="address?.line_two"
            :city="address?.city"
            :state="address?.state"
            :zip="address?.zip_code"
            :two-lines="true"
            :icon-color="iconsColor"
          />
        </div>
        <div>
          <RenderPhone v-if="guardian.phone" :phone="guardian.phone.number.toString()" :icon-color="iconsColor" />
        </div>
        <div class="flex-1">
          <RenderEmail v-if="guardian.email" :email="guardian.email" :icon-color="iconsColor" />
        </div>
      </div>
      <div class="flex-1">
        <div class="flex" v-if="guardian.is_address_same_as_main">
          <RenderYesNoAnswer :question="'Same address as primary applicant?'" :answer="true"  :title-class="titleClass"/>
        </div>
      </div>
    </div>
  </div>
</template>
